import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18343d39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-payment" }
const _hoisted_2 = { class: "primary__dark__color" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "gray__base__color" }
const _hoisted_5 = { class: "text-collapse d-flex align-center" }
const _hoisted_6 = { class: "card-text black__base__color" }
const _hoisted_7 = { class: "primary__dark__color dates__text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-right time-text gray__base__color" }, [
  /*#__PURE__*/_createElementVNode("span", null, " 2:00 PM")
], -1))
const _hoisted_9 = { class: "card-text black__base__color" }
const _hoisted_10 = { class: "primary__dark__color dates__text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-right time-text gray__base__color",
  style: {"margin-bottom":"15px"}
}, [
  /*#__PURE__*/_createElementVNode("span", null, " 12:00 PM")
], -1))
const _hoisted_12 = { class: "black__base__color" }
const _hoisted_13 = { class: "gray__base__color" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-right gray__base__color" }
const _hoisted_16 = { class: "text-right gray__base__color" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = {
  class: "total-price primary__color",
  style: {"margin-bottom":"0"}
}
const _hoisted_19 = { class: "pay-text black__base__color" }
const _hoisted_20 = { style: {"font-weight":"bold"} }
const _hoisted_21 = { class: "gray__base__color" }
const _hoisted_22 = { class: "mt-2 mb-2" }
const _hoisted_23 = { class: "primary__color coupon__title" }
const _hoisted_24 = { class: "gray__base__color" }

import {
  defineComponent,
  ref,
  reactive,
  watch,
} from "vue";
import { Booking, BookingRoomData } from "@/vue-core/models/HotelBooking.model";
import { ShoppingCart } from "@/models/events/checkout/shopping-cart.model";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingDetails',
  props: {
  bookingData: Object as () => Booking,
  shoppingCart: Object as () => ShoppingCart,
},
  emits: ["update:comments"],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;




const additionalComments = ref("");
const isSelectedAddComments = ref(false);

__expose({
  additionalComments,
});
function getFormat(amount) {
  return amount.toFixed(2);
}
function filterDate(date) {
  const month = date.toLocaleString("default", {
    month: "long",
  });
  const day = date.toLocaleString("default", {
    weekday: "long",
  });
  return `${day.charAt(0).toUpperCase() + day.slice(1)}, ${
    month.charAt(0).toUpperCase() + month.slice(1)
  } ${date.getDate()}, ${date.getFullYear()}`;
}
function totalTaxes(booking: Booking) {
  let totalTax = 0;
  let totalCharge = 0;
  let totalTaxRoom = 0;
  if (booking.cartRooms)
    booking.cartRooms.forEach((element) => {
      element.product["taxes"].forEach((item) => {
        totalTax += item.price;
      });
      totalTax = totalTax * element.quantity;
      totalTaxRoom += totalTax;
      totalTax = 0;
    });
  if (booking.charges)
    booking.charges.forEach((element) => {
      totalCharge += element.subtotal;
    });
  return totalTaxRoom + totalCharge;
}
function getIVA(amount) {
  const amountIVA = amount - amount / 1.16;
  return getFormat(amountIVA);
}
const subtotalAmount = (shoppingCart: ShoppingCart) => {
  let subtotalAmount = 0;
  let currency = "";
  if (shoppingCart.subtotals) {
    subtotalAmount = shoppingCart.subtotals[0].amount / 1.16;
    currency = " " + shoppingCart.subtotals[0].currency;
  }
  return subtotalAmount.toFixed(2) + currency;
};
const getRoomsNames = (booking: Booking) => {
  const rooms = booking.rooms;
  let roomsNames = "";
  for (let i = 0; i < rooms.length; i++) {
    roomsNames = `${roomsNames}${rooms[i].name} x ${rooms[i].quantityPerNight}`;
    if (i < rooms.length - 1) {
      roomsNames = roomsNames + " , ";
    }
  }
  return roomsNames;
};
const getRoomName = (room, nights) => {
  let roomName = "";
  roomName = `${roomName}  ${room.product.name} x ${room.quantity / nights}`;
  return roomName;
};
const getRoomsQuanity = (booking: Booking) => {
  const rooms = booking.rooms;
  let roomsQuantity = 0;
  rooms.forEach((room) => {
    roomsQuantity += room.quantityPerNight;
  });
  return roomsQuantity;
};

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_templete = _resolveComponent("templete")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("hotels.bookingCheckout.myBooking")), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.bookingData.hotel.name), 1),
    _hoisted_3,
    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.bookingData.hotel.address), 1),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 16,
          lg: 16,
          xl: 16
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, { accordion: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, null, {
                  title: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(getRoomsNames(__props.bookingData)), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      shadow: "never",
                      class: "card-dates"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("hotels.bookingCheckout.checkIn")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              span: 16,
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_7, _toDisplayString(filterDate(__props.bookingData.checkIn)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _hoisted_8,
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 8 }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("hotels.bookingCheckout.checkOut")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              span: 16,
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_10, _toDisplayString(filterDate(__props.bookingData.checkOut)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _hoisted_11,
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 14 }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("hotels.bookingCheckout.averageRate")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              span: 8,
                              class: "d-flex align-center ml-1"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_divider),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.bookingData.cartRooms, (room) => {
                          return (_openBlock(), _createBlock(_component_el_row, { key: room }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 14 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(getRoomName(room, __props.bookingData.nights)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, {
                                span: 8,
                                class: "d-flex align-center ml-1"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_13, " $" + _toDisplayString(getFormat(room.product.amount)) + " " + _toDisplayString(room.product.currency), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_divider)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_el_row, {
                          type: "flex",
                          justify: "end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 16 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_card, {
                                  class: "card-box",
                                  shadow: "never"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(__props.bookingData.nights) + " " + _toDisplayString(_ctx.$t("hotels.bookingCheckout.nights")) + ", " + _toDisplayString(getRoomsQuanity(__props.bookingData)) + " " + _toDisplayString(_ctx.$t("hotels.bookingCheckout.rooms")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 6,
          lg: 6,
          xl: 6,
          class: "d-flex align-center ml-1"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, " $ " + _toDisplayString(subtotalAmount(__props.shoppingCart)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (__props.shoppingCart && __props.shoppingCart.items)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.shoppingCart.items, (item) => {
            return (_openBlock(), _createElementBlock("div", { key: item }, [
              (item.product.roomType)
                ? (_openBlock(), _createBlock(_component_templete, { key: 0 }))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createVNode(_component_el_divider),
          (totalTaxes(__props.bookingData) > 0)
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0,
                style: {"margin-top":"2rem"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 12,
                    class: "black__base__color"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("hotels.bookingCheckout.taxesFees")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 12,
                    class: "text-right gray__base__color"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("$ " + _toDisplayString(getFormat(totalTaxes(__props.bookingData))) + " " + _toDisplayString(__props.shoppingCart.subtotals[0].currency), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_row, { class: "mt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 16,
                class: "black__base__color"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("hotels.bookingCheckout.subtotal")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 6,
                class: "d-flex align-center ml-1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_15, " $ " + _toDisplayString(subtotalAmount(__props.shoppingCart)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "mt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 16,
                class: "black__base__color"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("hotels.bookingCheckout.IVA")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 6,
                class: "d-flex align-center ml-1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_16, " $ " + _toDisplayString(getIVA(__props.shoppingCart.subtotals[0].amount)) + " " + _toDisplayString(__props.shoppingCart.subtotals[0].currency), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", _hoisted_18, " $" + _toDisplayString(getFormat(__props.shoppingCart.subtotals[0].amount)) + " " + _toDisplayString(__props.shoppingCart.subtotals[0].currency), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("hotels.bookingCheckout.for")) + " " + _toDisplayString(getRoomsQuanity(__props.bookingData)) + " " + _toDisplayString(_ctx.$t("hotels.bookingCheckout.rooms")) + ", " + _toDisplayString(__props.bookingData.adultSelected + __props.bookingData.childSelected) + " " + _toDisplayString(_ctx.$t("hotels.bookingCheckout.guest")) + ", " + _toDisplayString(__props.bookingData.nights) + " " + _toDisplayString(_ctx.$t("hotels.bookingCheckout.nights")), 1),
              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("hotels.bookingCheckout.includingTaxes")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_checkbox, {
      class: "gray__base__color",
      style: {"margin-top":"10px"},
      modelValue: isSelectedAddComments.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isSelectedAddComments).value = $event))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("hotels.bookingCheckout.additionalComments")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (isSelectedAddComments.value)
      ? (_openBlock(), _createBlock(_component_el_input, {
          key: 1,
          type: "textarea",
          modelValue: additionalComments.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((additionalComments).value = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_divider),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("coupon.couponTitle")), 1),
              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("coupon.coupon")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})